import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

// Pages
const HomePage = React.lazy(() => import('../pages/HomePage'));
const Blocked = React.lazy(() => import('../pages/Blocked'));
const Posts = React.lazy(() => import('../pages/Posts'));
const Gain = React.lazy(() => import('../pages/Gain'));
const Payments = React.lazy(() => import('../pages/Payments'));
const Payouts = React.lazy(() => import('../pages/Payouts'));
const Subscribers = React.lazy(() => import('../pages/Subscribers'));
const Support = React.lazy(() => import('../pages/Support'));
const MyAccount = React.lazy(() => import('../pages/MyAccount'));
const Statistics = React.lazy(() => import('../pages/Statistics'));
const PublisherStatistics = React.lazy(() => import('../pages/PublisherStatistics'));
const Login = React.lazy(() => import('../pages/Login'));
const Loading = React.lazy(() => import('../pages/Loading'));

const AppRouter = () => {
    return (
        <BrowserRouter>
            <Routes>
                <Route path='/' element={
                    <React.Suspense fallback={<Loading />}>
                        <HomePage />
                    </React.Suspense>
                } />
                <Route path='/posts' element={
                    <React.Suspense fallback={<Loading />}>
                        <Posts />
                    </React.Suspense>
                } />
                <Route path='/gain' element={
                    <React.Suspense fallback={<Loading />}>
                        <Gain />
                    </React.Suspense>
                } />
                <Route path='/payments' element={
                    <React.Suspense fallback={<Loading />}>
                        <Payments />
                    </React.Suspense>
                } />
                <Route path='/support' element={
                    <React.Suspense fallback={<Loading />}>
                        <Support />
                    </React.Suspense>
                } />
                <Route path='/my-account' element={
                    <React.Suspense fallback={<Loading />}>
                        <MyAccount />
                    </React.Suspense>
                } />
                <Route path='/payouts' element={
                    <React.Suspense fallback={<Loading />}>
                        <Payouts />
                    </React.Suspense>
                } />
                <Route path='/statistics' element={
                    <React.Suspense fallback={<Loading />}>
                        <Statistics />
                    </React.Suspense>
                } />
                <Route path='/publisher-statistics' element={
                    <React.Suspense fallback={<Loading />}>
                        <PublisherStatistics />
                    </React.Suspense>
                } />
                <Route path='/login' element={
                    <React.Suspense fallback={<Loading />}>
                        <Login />
                    </React.Suspense>
                } />
                <Route path='/blocked' element={
                    <React.Suspense fallback={<Loading />}>
                        <Blocked />
                    </React.Suspense>
                } />
                <Route path='/subscribers' element={
                    <React.Suspense fallback={<Loading />}>
                        <Subscribers />
                    </React.Suspense>
                } />
            </Routes>
        </BrowserRouter>
    )
}

export default AppRouter